/* sb-lp-th.js — "Welcome to the Tea House" QR landing page interactions.
   Progressive enhancement: without JS the page renders fully visible. */
(function () {
  'use strict';

  document.documentElement.classList.add('sb-th-js');

  function init() {
    if (!document.querySelector('.sb-th')) return;
    /* each Shopify section has its own .sb-th wrapper — query document-wide */

    reveal(document);
    films(document);

    /* kinetic hero letters */
    document.querySelectorAll('.sb-th [data-kinetic]').forEach(function (line) {
      var text = line.textContent;
      line.textContent = '';
      for (var i = 0; i < text.length; i++) {
        var s = document.createElement('span');
        s.className = 'lt';
        /* inline-block spans collapse plain spaces — use NBSP */
        s.textContent = text[i] === ' ' ? ' ' : text[i];
        line.appendChild(s);
      }
    });

    /* follow-cursor pearl (fine pointers; CSS hides it otherwise) */
    var pearl = document.querySelector('.sb-th-pearl');
    if (pearl && window.matchMedia('(pointer:fine)').matches &&
        !window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
      var px = -100, py = -100, tx = -100, ty = -100;
      window.addEventListener('pointermove', function (e) { tx = e.clientX + 22; ty = e.clientY + 26; }, { passive: true });
      (function roll() {
        px += (tx - px) * 0.12; py += (ty - py) * 0.12;
        pearl.style.top = py + 'px'; pearl.style.left = px + 'px';
        requestAnimationFrame(roll);
      })();
    }

    /* hot / iced toggle — texts come from data attributes set by Liquid */
    document.querySelectorAll('.sb-th .weather').forEach(function (weather) {
      var target = document.getElementById(weather.getAttribute('data-target') || '');
      if (!target) return;
      var title = target.querySelector('[data-w-title]');
      var body = target.querySelector('[data-w-body]');
      weather.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          weather.querySelectorAll('button').forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          if (title) title.textContent = btn.getAttribute('data-title') || '';
          if (body) body.textContent = btn.getAttribute('data-body') || '';
        });
      });
    });

    /* club echo — hover a link, the sidebar talks */
    var echo = document.getElementById('sb-th-echo');
    if (echo) {
      var echoDefault = echo.textContent;
      document.querySelectorAll('.sb-th .club-links a').forEach(function (a) {
        var say = function () { if (a.getAttribute('data-echo')) echo.textContent = a.getAttribute('data-echo'); };
        var reset = function () { echo.textContent = echoDefault; };
        a.addEventListener('mouseenter', say);
        a.addEventListener('focus', say);
        a.addEventListener('mouseleave', reset);
        a.addEventListener('blur', reset);
      });
    }

  }

  /* Scroll reveals. In the theme editor, show everything at once: the editor
     re-renders a section after each edit and the observer never sees the new
     nodes, so they would stay faded. */
  var io = null;
  function reveal(root) {
    var els = root.querySelectorAll('.sb-th .rv:not(.in)');
    if (!els.length) return;
    var designMode = window.Shopify && window.Shopify.designMode;
    if (designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* film placeholders with a video URL — swap in the player on click */
  function films(root) {
    root.querySelectorAll('.sb-th .film[data-video]').forEach(function (film) {
      if (film.dataset.bound) return;
      film.dataset.bound = '1';
      film.addEventListener('click', function () {
        if (film.querySelector('video')) return;
        var url = film.getAttribute('data-video');
        if (!url) return;
        var v = document.createElement('video');
        v.src = url; v.controls = true; v.autoplay = true; v.playsInline = true;
        film.appendChild(v);
        v.play().catch(function () {});
      });
    });
  }

  /* the theme editor re-renders one section at a time */
  document.addEventListener('shopify:section:load', function (e) {
    reveal(e.target);
    films(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
